import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { MdLock, MdPublic } from 'react-icons/md';
import { UserList } from '../../types/types';
interface PropTypes {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  data: UserList;
  className?: string;
}
const UserListBasicItem = t0 => {
  const $ = _c(17);
  const {
    data,
    onClick,
    className
  } = t0;
  const t1 = `flex flex-row rounded-md bg-black cursor-pointer p-2 hover:opacity-[0.4] ${className}`;
  let t2;
  if ($[0] !== data.thumbnail?.file_path) {
    t2 = data.thumbnail?.file_path ? <img className="w-[80px] h-[44.94px] rounded-md border-solid border-[1px] border-gray-200" width="80px" src={`https://cdn-proxy.trakio.app/t/p/w300${data.thumbnail?.file_path}`} /> : <img className="w-[80px] h-[44.94px] rounded-md border-solid border-[1px] border-gray-200" src="/assets/app/wallpaper-fallback.jpg" />;
    $[0] = data.thumbnail?.file_path;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== data.name) {
    t3 = <span className="text-white font-bold line-clamp-1 text-ellipsis">{data.name}</span>;
    $[2] = data.name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data.privacy) {
    t4 = data.privacy === "private" && <MdLock />;
    $[4] = data.privacy;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== data.privacy) {
    t5 = data.privacy === "public" && <MdPublic />;
    $[6] = data.privacy;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-col rounded-md ml-2 flex-1 overflow-hidden">{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onClick || $[13] !== t1 || $[14] !== t2 || $[15] !== t6) {
    t7 = <div className={t1} onClick={onClick}>{t2}{t6}</div>;
    $[12] = onClick;
    $[13] = t1;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default UserListBasicItem;